export default {
	common: {
		search_for: 'Search: {query}',
		online: 'Online',
		offline: 'Offline',
		view_details: 'View details',
		clear: 'Clear',
	},
	sidebar: {
		header_me: 'Welcome, {firstname}!',
		header_admin: 'Administration',
		tools: {
			_: 'Tools',
			decommission: 'Decommission',
			site_search: 'UniFi Site Search',
			prepare_site: 'UniFi Site Prepare',
		},
	},
	tabs: {
		admin_settings: {
			network_lists: 'Network lists',
		},
	},
	pages: {
		home: {
			welcome_text: 'Hello World',
		},
		admin: {
			settings: {
				network_lists: {
					vlan: {
						title: 'VLAN Lists',
						columns: {
							vlan_id: 'VLAN ID (1-4093)',
							name: 'Name of the VLAN',
							subnet: 'Subnet of the VLAN in CIDR notation',
							router_ip: 'IP address of the router',
							dhcp_start: 'First IP address of the DHCP pool',
							dhcp_end: 'Last IP address of the DHCP pool',
						},
					},
					fixed_ip: {
						title: 'Fixed IP Lease Lists',
						columns: {
							mac: 'MAC address of the host',
							hostname: 'Hostname of the host',
							ip: 'IP address of the host',
							vlan_id: 'VLAN ID in which to create the static lease',
						},
					},
					columns: {
						name: 'File',
						size: 'Size',
						last_modified: 'Last modified',
					},
					default: 'Default',
					set_default: 'Set as default',
					empty: 'No lists uploaded yet',
					delete_confirm: {
						title: 'Delete list?',
						body: 'Are you sure you want to delete "{name}"? This cannot be undone.',
					},
					upload: {
						title: 'Upload {list}',
						submit: 'Upload',
						no_file: 'Please choose a CSV file to upload.',
						failed: 'The file could not be uploaded.',
						hint_vlan: 'Expected a comma-separated CSV with columns:',
						hint_fixed_ip: 'Expected a semicolon-separated CSV with columns:',
					},
					toasts: {
						load_failed: {
							title: 'Loading failed',
							body: 'Failed to load the network lists',
						},
						uploaded: {
							title: 'List uploaded',
							body: '"{name}" was uploaded successfully',
						},
						delete_failed: {
							title: 'Delete failed',
							body: 'The list could not be deleted',
						},
						default_failed: {
							title: 'Could not set default',
							body: 'The default list could not be updated',
						},
					},
				},
			},
		},
		tools: {
			decommission: {
				title: 'Decommission',
				status: {
					unknown: 'Unknown status',
					waiting: 'Waiting to run ...',
					searching: 'Searching for device "{device_code}" ...',
					running: 'In progress ...',
					success: 'Completed',
					failed: 'Failed: {error}',
					failed_step: 'Failed during {step}: {error}',
					waiting_on_step: 'Waiting for {step}',
				},
				exceptions: {
					unknown: 'Unknown error',
					no_device_data: 'No device data',
					not_found: 'Not found',
					device_not_supported: 'Unknown device type',
					invalid_device_code: 'Invalid label "{device_code}"',
					uncallable_step: 'Step "{step_name}" does not exist',
					default_vlan_list_not_set:
						'No default VLAN list is set. Please set one in the network lists settings before decommissioning switches.',
					default_site_not_found: 'The UISP site "Default" does not exist',
					tcm_not_es8: 'The TCM device "{code}" is not an EdgeSwitch 8',
				},
				toasts: {
					request_running: {
						title: 'Request queued',
						body: 'The request for device code "{device_code}" is already queued',
					},
					requeue_request: {
						title: 'Request already completed',
						body: 'The request for device code "{device_code}" has already been completed. Scan the device again to start another request.',
					},
					failed_to_queue: {
						title: 'Request failed',
						body: 'The request for device code "{device_code}" could not be created: {error}',
					},
				},
				steps: {
					unknown: 'Unknown step',
					waitForDeviceOnline: 'Wait for device',
					enableMaintenance: 'Enable maintenance',
					moveToDefaultSite: 'Move to default site',
					setDeviceName: 'Set device name',
					updateVlanList: 'Update VLANs',
					configurePorts: 'Configure ports',
					waitForProvisioning: 'Wait for provisioning',
					startDeviceLocate: 'Start device locate',
				},
			},
			site_search: {
				title: 'UniFi Site Search',
				search_label: 'Enter your search term',
				search_placeholder: 'Device name or MAC address ...',
				search_failed: 'Search failed',
				no_results: 'No results for "{query}"',
				status: {
					ambiguous: 'Multiple devices found',
					ready: 'Ready to move',
					moving: 'Moving ...',
					moved: 'Moved',
				},
				multiple_results: 'Found multiple matching devices:',
			},
			prepare_site: {
				title: 'UniFi Site Prepare',
				select_site: 'Select your UniFi site',
				select_placeholder: 'Select ...',
				loading_sites: 'Loading sites ...',
				loading_summary: 'Loading site details ...',
				stats: {
					online_for: 'Site online for',
					offline: 'Offline',
					online_devices: 'Online devices',
					active_clients: 'Active clients',
					access_points: 'APs (Online/Total)',
					switches: 'Switches (Online/Total)',
					routers: 'Routers (Online/Total)',
					networks: 'Networks (Enabled/Total)',
					wireless_networks: 'WiFi SSIDs (Enabled/Total)',
				},
				options: {
					title: 'Site options',
					import_vlans: 'Import VLANs',
					import_vlans_only: 'Import VLANs without subnets',
					overwrite_existing_vlans: 'Overwrite existing VLANs',
					vlan_list: 'VLAN list',
					import_fixed_ips: 'Import fixed IPs from CSV',
					fixed_ip_list: 'Fixed IP list',
					purge_networks: 'Purge all existing VLANs',
					purge_wireless_networks: 'Purge all existing WiFi SSIDs',
					purge_fixed_ips: 'Purge all existing fixed IPs',
					reset_access_point_configurations: 'Reset custom AP configurations',
					enable_wan_dhcp: 'Set any existing routers to use DHCP on WAN',
				},
				prepare: 'Prepare site',
				back: 'Back',
				eligibility: {
					blocked_reason:
						'Site "{site}" has been online for a while and looks like a live site, so it cannot be prepared. Preparation is destructive and is only allowed on freshly set up or offline sites.',
				},
				progress_title: 'Preparation of site "{site}"',
				history: {
					title: 'Site preparation history',
					back: 'Back to tool',
					running: 'Running ...',
					steps: 'Steps',
					columns: {
						id: 'ID',
						site_description: 'Site',
						site_name: 'Internal site name',
						created_at: 'Queued at',
						completed_at: 'Completed at',
						error: 'Status',
					},
				},
				confirm: {
					title: 'Prepare site?',
					body: 'Are you sure you want to prepare site "{site}"? This reconfigures the site with the selected options.',
				},
				status: {
					waiting: 'Waiting for execution ...',
					success: 'Site preparation completed',
					failed: 'Site preparation failed: {error}',
				},
				errors: {
					unknown: 'Unknown error',
				},
				toasts: {
					load_failed: {
						title: 'Loading failed',
						body: 'Failed to load UniFi site data',
					},
					failed_to_queue: {
						title: 'Request failed',
						body: 'The site preparation for site "{site}" could not be queued',
					},
					completed: {
						title: 'Site prepared',
						body: 'Site "{site}" was prepared successfully',
					},
					failed: {
						title: 'Site preparation failed',
						body: 'The preparation of site "{site}" has failed',
					},
				},
			},
		},
	},
	exceptions: {
		no_device_data: 'No device data found',
	},
	modules: {
		etherforce: {
			network_devices: {
				exceptions: {
					device_not_found: 'No device found for "{identifier}"',
					device_unreachable: 'Device {device_name} is unreachable',
					invalid_device_code: 'Invalid device label code "{device_code}"',
					no_controller_service:
						'Device "{identifier}" has a valid type, but no network controller service exist to handle it',
					unknown_device_type: 'Device "{identifier}" has an unknown device type',
				},
			},
		},
	},
};
